// What the dock's Chat control shows, from the store.

/**
 * A joined room, a DM conversation or a match: something the sheet can open.
 * An unread DM counts before the DM list has loaded (it loads with the sheet).
 */
export function dockChatHasConversations(state) {
	const rooms = state.chat && state.chat.myChatRooms;
	const privateChat = state.privateChat || {};
	const dms = privateChat.openPrivateChats;
	const match = state.matchmaking && state.matchmaking.currentMatch;
	return !!((rooms && rooms.size) || (dms && Object.keys(dms).length) || privateChat.unreadPrivateMessageCount || match);
}

/** @ for a mention; count: conversations with unread messages (rooms, then DMs). */
export function dockChatBadge(state) {
	const chat = state.chat || {};
	const unreadRooms = Object.keys(chat.chatsWithUnreadMessages || {}).length;
	const unreadDms = (state.privateChat && state.privateChat.unreadPrivateMessageCount) || 0;
	return { mention: !!chat.aChatHasNewMentions, count: unreadRooms + unreadDms };
}
